// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Storing.ts.
import { TaskType } from '../../types/tasks.js';
import { Asset } from '../../types/assets.js';
import { InGameEffect } from '../../types/inGameEffect.js';
import { SparePart } from '../../types/storage.js';
const effect = (asset) => [
    {
        type: InGameEffect.resolveMalfunction,
        description: 'Verwijder een storing van de machine, reset slijtage naar 0',
        asset,
    },
];
/**
 * Niet zoals het origineel: storing1 vraagt nu een watertoevoerklep en storing5 een
 * aandrijving, de onderdelen die hun tekst al noemt en die in de risicomatrix staan. De
 * kaarten zonder onderdeel van €5.000 en €6.000 en storing2 en storing5 zijn goedkoper. In
 * het origineel kwamen ze nooit op tafel. Met de loting (`lotStoring`) wel; zonder
 * lagere prijs zou repareren per spel zo'n €9.000 duurder worden.
 */
export const StoringsTaken = [
    {
        _id: 'storing0',
        type: TaskType.storing,
        specificAsset: Asset.mixer,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'De mixer is vastgelopen door een ophoping van resten om de draaias',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'storing1',
        type: TaskType.storing,
        specificAsset: Asset.mixer,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'Door een elektrische storing zijn motor, watertoevoer en meeltoevoer uit sync',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.watertoevoerklep,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'storing2',
        type: TaskType.storing,
        specificAsset: Asset.mixer,
        title: 'Correctief onderhoud',
        cost: 4000,
        description: 'De mixer krijg geen meel meer toegeleverd door een kapotte klep in de meeldoseerder',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.meelDoseerder,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'storing3',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineA,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'Door te grote druk is de vormwals niet langer rond, maar afgeplat op een zijkant',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.deegwals,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'storing4',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineA,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'Door trillingen bij het walsen zijn verschillende connectoren in de machine losgekomen',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'storing5',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineA,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'Een storing in de snelheidregulator van de aandrijving zorgt voor doorvoer problemen',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.aandrijving,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'storing6',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineB,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'De aandrijfsnaar is gebroken door een scherpe kant aan het aandrijfwiel',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.aandrijving,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'storing7',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineB,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'De vorm van onze koeken zijn ongelijk en ze komen niet door onze quality control',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.deegwals,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'storing8',
        type: TaskType.storing,
        specificAsset: Asset.vormmachineB,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'Deegresten na het vormen blijven liggen door een los gekomen afvoersnaar',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'storing9',
        type: TaskType.storing,
        specificAsset: Asset.koeler,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'De koeken koelen niet doordat er geen warme lucht wordt afgevoerd, wegens een verstopt luchtfilter',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.luchtfilters,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'storing10',
        type: TaskType.storing,
        specificAsset: Asset.koeler,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'Door een kapotte doorvoerband blijven koeken in de koeler steken',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.doorvoerband,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'storing11',
        type: TaskType.storing,
        specificAsset: Asset.koeler,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'De elektromotor komt niet op gang door een wisselende stroomtoevoer',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'storing12',
        type: TaskType.storing,
        specificAsset: Asset.oven,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'De oven blijft op een aantal plekken koud doordat een verwarmingselement kapot is gegaan',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.verwarmingselement,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'storing13',
        type: TaskType.storing,
        specificAsset: Asset.oven,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'Een probleem met de thermostaat zorgt voor hoge themperaturen en zwarte koeken',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.thermostaat,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'storing14',
        type: TaskType.storing,
        specificAsset: Asset.oven,
        title: 'Correctief onderhoud',
        cost: 3000,
        description: 'Een elektrische storing in het sluitmechanisme van de ovendeuren heeft de over praktisch afgesloten',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'storing15',
        type: TaskType.storing,
        specificAsset: Asset.inpakker,
        title: 'Correctief onderhoud',
        cost: 2000,
        description: 'Er kan geen vacuum meer getrokken worden en iets opgepakt worden door de versleten vacuuum gripper',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.vacuumGripper,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.inpakker),
    },
    {
        _id: 'storing16',
        type: TaskType.storing,
        specificAsset: Asset.inpakker,
        title: 'Correctief onderhoud',
        cost: 4000,
        description: 'Een deel van de flexpicker is gebroken en de controle kabel is losgekomen',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: true,
        sparepartNeeded: SparePart.flexpicker,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.inpakker),
    },
    {
        _id: 'storing17',
        type: TaskType.storing,
        specificAsset: Asset.inpakker,
        title: 'Correctief onderhoud',
        cost: 4000,
        description: 'Een fout in de sensor aansluiting zorgt ervoor dat de machine niet kan starten',
        inGameEffectDescription: 'Verwijder een storing van de machine, reset slijtage naar 0',
        inGameEffect: [InGameEffect.resolveMalfunction],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 0,
        taskEffects: effect(Asset.inpakker),
    },
];
